
import Vue from "vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import VueI18n from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";
import {getTranslatedIsoLangName, getTranslatedIsoLangNames, LanguageNamesDict} from "@/utils/languages";
import { LanguagesConfig } from "@/models/dossier-configs/languages";

export default Vue.extend({
	data() {
		return {
			selectedLanguage: "",
			translatedNames: {} as LanguageNamesDict
		};
	},
	props: {
		value: String,
		fancy: Boolean,
		disabled: Boolean,
		label: [String, Object as () => VueI18n.TranslateResult]
	},
	computed: {
		languages():LanguagesConfig{
			return DossierConfigService.getLanguages();
		},
		languageItems(): ISelectItem<string>[] {
			let l = this.languages.LanguageNames.map(l => {
				return {
					text: getTranslatedIsoLangName(l, this.translatedNames),
					value: l
				};
			});
			l.push({text: this.$ct("copy-to-all-languages").toString(), value: "copy"});
			return l;
		},
		_label(): String | VueI18n.TranslateResult {
			if (!this.label) {
				return "";
			}
			return this.label;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(value: string) {
				if (value == "" || value == "copy") return;
				if (value == this.selectedLanguage) return;
				this.selectedLanguage = value;
			}
		},
		selectedLanguage: {
			handler(value: string) {
				if (value == this.value) return;
				if(value=="copy"){
					this.$emit("copy-to-all-languages");
					return;
				}
				this.$emit("input", value);

			}
		}
	},
	methods: {

	},
	async mounted() {
		this.translatedNames = await getTranslatedIsoLangNames();
		if (this.selectedLanguage == "" && this.languages.LanguageNames.length > 0) {
			this.selectedLanguage = this.languages.LanguageNames[0];
			this.$emit("input", this.selectedLanguage);
		}
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
